<script setup lang="ts">
import { SelectIcon, SelectTrigger, type SelectTriggerProps } from 'reka-ui'
import { ChevronDown } from 'lucide-vue-next'
import { cn } from '@/lib/utils'

const props = withDefaults(
  defineProps<SelectTriggerProps & { class?: string; invalid?: boolean }>(),
  {
    class: '',
    invalid: false,
  },
)
</script>

<template>
  <SelectTrigger
    v-bind="props"
    :class="cn(
      'flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-2 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
      props.class,
      props.invalid && 'ring-destructive! ring-2 placeholder:text-destructive!'
    )"
  >
    <div class="flex items-center justify-between w-full">
      <slot />
      <SelectIcon as-child>
        <ChevronDown class="min-w-4.5 w-4.5 min-h-4.5 h-4.5 opacity-50" />
      </SelectIcon>
    </div>
  </SelectTrigger>
</template>
